import React from 'react';
import AdminDashbord from './AdminDashbord';
import { Outlet } from 'react-router-dom';

const AdminLayout = () => (
  <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
    <AdminDashbord />
    <main style={{ flexGrow: 1, padding: '1rem', overflowY: 'auto' }}>
      <Outlet />
    </main>
  </div>
);

export default AdminLayout;
